import { isStaffRole } from '@/hooks/useAdminAuth';

export interface RoutingProfile {
  role: string | null;
  is_helper: boolean | null;
  profile_status?: string | null;
}

export interface RoutingMetadata {
  is_helper?: boolean;
  role?: string;
  signup_role?: string;
}

export type AccountRole = 'staff' | 'helper' | 'client' | 'undecided';

/** One role decision for /post-auth, /dashboard and the legacy /profile URL. */
export function resolveAccountRole(
  profile: RoutingProfile | null,
  roles: readonly string[],
  metadata: RoutingMetadata | null | undefined,
): AccountRole {
  // user_roles is authoritative for staff, even when profiles.role is 'client'.
  if (roles.some(isStaffRole) || profile?.role === 'admin') return 'staff';
  if (!profile) {
    return metadata?.is_helper || metadata?.role === 'helper' || metadata?.signup_role === 'helper'
      ? 'helper'
      : 'undecided';
  }
  // NULL is_helper without an explicit declaration means the role chooser.
  if (profile.is_helper === null && profile.role !== 'client' && profile.role !== 'helper') {
    return 'undecided';
  }
  if (profile.role === 'helper' || profile.is_helper) return 'helper';
  return 'client';
}

export function accountDestination(
  role: AccountRole,
  profile: RoutingProfile | null,
  context: 'dashboard' | 'profile',
): string {
  if (role === 'staff') return '/admin';
  if (role === 'undecided') return '/profile-creation';
  if (role === 'helper') {
    if (context === 'profile' && profile?.profile_status === 'approved') return '/helper-account';
    return profile?.profile_status === 'approved' ? '/helper-dashboard' : '/helper-profile';
  }
  return context === 'profile' ? '/client-account' : '/client-dashboard';
}
